<template>
    <footer id="footer">
         <div class="inner">
            <section >
				<h2>Unternehmen eintragen</h2>
                <div >Du bist vom Round Table | Ladies Circle | Old Tablers | Tangent Club und möchtest in die Übersicht mit aufgenommen werden, dann kannst du dich <router-link to="/eintragen" class="body-2 font-weight-bold primary-color">HIER</router-link> eintragen.</div>
                <div style="display:none">Du bist vom Round Table oder Ladies Circle und möchtest in die Übersicht mit aufgenommen werden, dann schreibe mir über das nachstehende Formular.</div>
            </section>

            <RTdonate text="Möchtest du den Fortbestand sowie Weiterentwicklungen dieser Seite sichern, dann unterstütze mich durch einen Klick auf:"/>

        </div>
        <div class="inner mt-4">
            <section>
                <h2>Get in touch</h2>
                <form>
                    <div class="fields mb-1">
                        <div class="field half">
                            <input v-model="name" type="text" name="name" id="name" placeholder="Name" />
                        </div>
                        <div class="field half">
                            <input v-model="email" type="email" name="email" id="email" placeholder="E-Mail" />
                        </div>
                        <div class="field">
                            <textarea v-model="message" name="message" id="message" placeholder="Nachricht"></textarea>
                        </div>
                        <div class="field">
                            <input type="checkbox" id="dsgvo-check" name="dsgvocheck"  v-model="dsgvoChecked">
                            <label for="dsgvo-check">Ich habe die <a href="#" @click.stop.prevent="showDatenschutzModal">Datenschutzbestimmungen</a> für die Verarbeitung meiner persönlichen Daten gelesen</label>
                        </div>
                    </div>
                    <ul class="actions">
                        <li v-if="!emailWasSend">
                            <input @click.stop.prevent="sendMail" type="submit" value="Absenden" class="primary" :disabled="!dsgvoChecked"/>
                        </li>
                        <li v-else>
                            <div style="color:green">Vielen Dank für deine Nachricht. Sie wurde erfolgreich übermittelt.</div>
                        </li>
                    </ul>
                </form>
            </section>
            <section>
                <h2>Social</h2>
                <ul class="icons">
                    <li><a href="https://www.facebook.com/twobeers.hubold" target="_blank" class="icon brands style2 fa-facebook-f"><span class="label">Facebook</span></a></li>
                    <li><a href="https://www.linkedin.com/in/tobias-hubold/" target="_blank" class="icon brands style2 fa-linkedin"><span class="label">LinkedIn</span></a></li>
                    <li><a href="https://www.xing.com/profile/Tobias_Hubold" target="_blank" class="icon brands style2 fa-xing"><span class="label">Xing</span></a></li>
                </ul>
            </section>

            <ul class="copyright mt-3">
                <li>Made with ♥ from <a target="_blank" href="https://tobiashubold.de">Tobias Hubold</a> von <a target="_blank" href="https://rt210.de">RT210 Jena</a></li>
                <li>Credits to <a target="_blank" href="https://html5up.net/">HTML5 UP</a></li>
                <li><a href="#" @click.prevent="showImpressModal">Impressum</a></li>
                <li><a href="#" @click.prevent="showDatenschutzModal">Datenschutz</a></li>
            </ul>
        </div>
        <RTmodal ref="impressModal">
            <RTimpressum/>
        </RTmodal>
        <RTmodal ref="datenschutzModal">
            <RTdatenschutz/>
        </RTmodal>
    </footer>
</template>

<script>
import RTmodal from '@/components/RTmodal.vue'
import RTimpressum from '@/components/RTimpressum.vue'
import RTdatenschutz from '@/components/RTdatenschutz.vue'
import RTdonate from '@/components/RTdonate.vue'

export default {
  name: 'RTFooter',
  components:{
    RTmodal,
	RTimpressum,
    RTdatenschutz,
    RTdonate
  },
  data: function() {
    return {
        dsgvoChecked:false,
        emailWasSend:false,
        message:"",
        name:"",
        email:""
    };
  },
  methods:{
    showImpressModal() {
        this.$refs.impressModal.show();
    },
    showDatenschutzModal() {
        this.$refs.datenschutzModal.show();
    },
    sendMail(){
        const bodyFormData = new FormData();
        bodyFormData.append('message', this.message);
        bodyFormData.append('name', this.name);
        bodyFormData.append('email', this.email);

        this.axios({
            method: 'post',
            url: '/email.php',
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
            })
          .then(()=>{
              this.emailWasSend=true;
              this.message="";
              this.name="";
              this.email="";
          })
          .catch((error)=>{
            console.log(error);
            this.emailWasSend=false;
          });
    },
  }
};
</script>

<style scoped type='text/css'>

</style>